export const DASHBOARD_PAGE_NAME = "Dashboard";
export const DASHBOARD_TABLE_NAME = "All Audits";